import { SearchError } from '../enums/searchError';
import {
	CarModelsResultModel,
	EditoinModelsResultModel,
	LanguageModelsResultModel,
	ManualsResultModel,
	MarketModelsResultModel,
	VinRecognitionResponse,
} from '../models';
import { ApiServiceError, BaseApiService } from './baseApiService';

export class ApiService extends BaseApiService {
	public getCarModels = (vin?: string) => {
		return this.get<CarModelsResultModel>('api/Models', { params: { vin } })
			.then((response) => response.results)
			.catch((error: ApiServiceError) => {
				if (error.status === 500) throw SearchError.RequestError;
				throw error;
			});
	};

	public getEditions = (model: string) => {
		return this.get<EditoinModelsResultModel>('api/Editions', { params: { model } }).catch((error: ApiServiceError) => {
			if (error.status === 400) throw SearchError.ParametersMismatch;
			throw SearchError.RequestError;
		});
	};

	public getMarkets = (model: string, edition: string) => {
		return this.get<MarketModelsResultModel>('api/Markets', { params: { model, edition } }).catch((error: ApiServiceError) => {
			if (error.status === 400) throw SearchError.ParametersMismatch;
			throw SearchError.RequestError;
		});
	};

	public getLanguages = (model: string, edition: string, market: string) => {
		return this.get<LanguageModelsResultModel>('api/Languages', { params: { model, edition, market } }).catch((error: ApiServiceError) => {
			if (error.status === 400) throw SearchError.ParametersMismatch;
			throw SearchError.RequestError;
		});
	};

	public getLanguagesForVin = (vin: string, token: string) => {
		return this.get<LanguageModelsResultModel>('api/Languages', { params: { vin }, headers: { 'ReCaptcha-Token': token } }).catch(
			(error: ApiServiceError) => {
				if (error.status === 500) throw SearchError.RequestError;
				throw error;
			}
		);
	};

	public getManuals = (model: string, edition: string, market: string, language: string, vin: string) => {
		return this.get<ManualsResultModel>('api/Manuals', { params: { model, edition, market, language, vin } }).catch((error: ApiServiceError) => {
			if (error.status === 400) throw SearchError.ParametersMismatch;
			throw SearchError.RequestError;
		});
	};

	public recognizeVinFromImage = (file: File) => {
		const body = new FormData();
		body.set('image', file);
		return this.post<VinRecognitionResponse>('api/recognize-vin', { body, noContentError: true });
	};
}
